<template>
  <svg id="Capa_1" enable-background="new 0 0 510 510" :width="width" :height="height" viewBox="0 0 510 510" xmlns="http://www.w3.org/2000/svg">
    <g :fill="color">
      <path
        d="m170 80c0-27.57 22.43-50 50-50 2.446 0 4.849.185 7.203.526-10.758 13.625-17.203 30.806-17.203 49.474v70h30v-70c0-13.953 5.751-26.583 15-35.662 9.249 9.079 15 21.709 15 35.662v70h-30v60h-30v-60h-40v360h280.697l-16.364-360h-59.333v60h-30v-60h-45v-70c0-18.668-6.445-35.849-17.203-49.474 0 0 3.388-.995 11.866-.995 27.57 0 50.337 22.899 50.337 50.469v70h30v-70c0-44.112-35.888-80-80-80h-5c-12.545 0-24.421 2.91-35 8.079-10.579-5.169-22.455-8.079-35-8.079-44.112 0-80 35.888-80 80v70h30z"
      />
      <path d="m140 150h-64.333l-16.364 360h80.697z" />
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    width: { type: String },
    height: { type: String },
    color: { type: String }
  }
}
</script>

<style></style>
